module.exports = __webpack_public_path__ + "img/siteIcons-02.47aea347.png";